module.exports = __webpack_public_path__ + "img/giftbag.3b50c7f1.svg";